/**
 * The organization a Contract Intelligence page acts on, its URL segment,
 * and whether the person manages it (from the domain API's profile read —
 * the same answer the server asks before an admin-only write).
 *
 * @module components/apps/contractIntelligence/useCiOrg
 */
import { orgUrlSegment } from "../../../orgRouting";
import { useOrgProfile } from "../../../state/orgProfile";
import { useRegulationOrg } from "../../regulation/useRegulationOrg";

export interface CiOrg {
  readonly organizationId: string | null;
  readonly orgSegment: string | null;
  readonly orgName: string | null;
  readonly canManage: boolean;
  readonly isLoading: boolean;
}

export function useCiOrg(): CiOrg {
  const { org, isLoading } = useRegulationOrg();
  const profile = useOrgProfile(org?.id ?? null);
  return {
    organizationId: org?.id ?? null,
    orgSegment: org ? orgUrlSegment(org.id) : null,
    orgName: org?.name ?? null,
    canManage: profile.profile?.canManage ?? false,
    isLoading,
  };
}
